import { useState, useRef, useEffect } from "react";
import { ChevronDown, Globe } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export const LanguageSwitcher = ({ className = "" }) => {
  const { lang, setLang, languages } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = languages.find((l) => l.code === lang) || languages[0];

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  return (
    <div ref={ref} className={`relative ${className}`}>
      <button
        data-testid="lang-switcher"
        onClick={() => setOpen((v) => !v)}
        aria-label="Choisir la langue"
        className="flex items-center gap-1.5 text-[#cbc1ad] hover:text-[#d89557] transition text-xs uppercase tracking-[0.18em] py-1"
      >
        <Globe className="w-4 h-4" />
        <span className="hidden sm:inline">{current.code}</span>
        <ChevronDown className={`w-3 h-3 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 min-w-[160px] bg-[#0a0a0a] border border-[#2a2422] shadow-2xl z-50">
          {languages.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm hover:bg-[#161514] transition text-left ${
                l.code === lang ? "text-[#d89557]" : "text-[#cbc1ad]"
              }`}
            >
              <span className="text-base">{l.flag}</span>
              <span className="uppercase tracking-[0.18em] text-xs">{l.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
